import type { IApiErrorResponse } from '../../../helpers/api/models';
import { STATUS_VIEW_ERRORS } from '../../../config/router';

import type { TChange } from './models';

export const handleResponseApiErrorStatus = (error: IApiErrorResponse, change: TChange) => {
    const { data } = error;
    const currentView = STATUS_VIEW_ERRORS[data.status] || STATUS_VIEW_ERRORS.TECHNICAL_ERROR;

    change('errorStatus', currentView);
};
